var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.98649 18.4865C13.9496 18.4865 17.973 14.4631 17.973 9.49998C17.973 4.53688 13.9496 0.513489 8.98649 0.513489C4.02339 0.513489 0 4.53688 0 9.49998C0 14.4631 4.02339 18.4865 8.98649 18.4865Z",
    fill: "url(#paint0_linear_1_24)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.06788 9.40498C6.68762 8.2636 8.43452 7.51113 9.30859 7.14757C11.8042 6.10955 12.3228 5.92923 12.6608 5.92321C12.7351 5.92197 12.9014 5.94039 13.009 6.02776C13.0999 6.10153 13.125 6.20118 13.1369 6.27112C13.1489 6.34107 13.1638 6.5004 13.152 6.62489C13.0167 8.04587 12.4315 11.4942 12.1338 13.0857C12.0079 13.7591 11.7598 13.9849 11.5197 14.007C10.9978 14.0551 10.6015 13.6622 10.0961 13.3308C9.30517 12.8124 8.85835 12.4896 8.09061 11.9837C7.20337 11.399 7.77853 11.0777 8.28417 10.5525C8.4165 10.415 10.7158 8.32362 10.7603 8.1339C10.7659 8.11017 10.7711 8.02172 10.7185 7.97502C10.666 7.92831 10.5884 7.94428 10.5325 7.95699C10.4531 7.97499 9.18962 8.81013 6.74191 10.4624C6.38327 10.7087 6.05842 10.8287 5.76736 10.8224C5.4465 10.8154 4.82929 10.641 4.37045 10.4918C3.80767 10.3089 3.36039 10.2122 3.39934 9.90147C3.41962 9.73964 3.64247 9.57415 4.06788 9.40498Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_24",
    x1: 8.98649,
    y1: 0.513489,
    x2: 8.98649,
    y2: 18.3531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTg);
export default __webpack_public_path__ + "static/media/tg.c717f6af395e67eeae1921714a277ca9.svg";
export { ForwardRef as ReactComponent };